import MicroModal from 'micromodal';

// Run the functions on document ready
document.addEventListener('DOMContentLoaded', () => {
    // form to get user first name and email
    const footerForm = document.querySelector('form.footer-subsription-form');
    const fullNameField = footerForm?.querySelector('#fullName');
    const emailField = footerForm.querySelector('#email');

    const footerNotificationWrapper = document.querySelector('.footer-subsription-notification');
    const footerNotificationSuccess = footerNotificationWrapper.querySelector('.notification-success');
    const footerNotificationError = footerNotificationWrapper.querySelector('.notification-error');

    // site subcription form from Kentico
    const modalFormWrapper = document.querySelector('#sitesubscriptionform');
    const modalForm = modalFormWrapper.querySelector('form');
    const modalFullNameField = modalForm.querySelector('.fullname input');
    const modalEmailField = modalForm.querySelector('.emailaddress input');

    const modalNotificationSuccess = modalFormWrapper.querySelector('.notification-success');
    const modalNotificationError = modalFormWrapper.querySelector('.notification-error');

    footerForm.addEventListener('submit', e => {
        e.preventDefault();
        modalFullNameField.value = fullNameField.value;
        modalEmailField.value = emailField.value;

        MicroModal.show('subscription-preference-form', {
            // on modal close after submission, show success/error notification on footer form
            onClose: () => {
                const submitResultSuccess = modalNotificationSuccess.classList.contains('hidden');
                const submitResultError = modalNotificationError.classList.contains('hidden');

                footerNotificationSuccess.classList.toggle('hidden', submitResultSuccess);
                footerNotificationError.classList.toggle('hidden', submitResultError);

                if (!submitResultSuccess || !submitResultError) {
                    footerForm.classList.add('sr-only');
                }
            }
        });
    });
});
